import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import InputField from "../../../generic/inputField";
import { asyncGetPersonalDetails } from "../../../service/postLogin/clientProfileAPIService";
import {
  GetFamilyRelationshipList,
  ServiceClientValidation,
  SendWhatsappConsent,
  CreateServiceRequestDetails,
  GetDepositoryDetails,
} from "../../../service/serviceRequest/srApiService";
import * as esignService from "../../../service/esign/esignService";
import { StatusScreen } from "../../generic/statusScreen";
import { FamilySection } from "./familySection";
import { emailRegex, integerExp } from "../../../utils/regex";
import { OtpSection } from "../../generic/otpSection";
import Loader from "../../../generic/loader";
import Checkbox from "../../../generic/checkbox";
import { useQuery } from "../../../service/urlHelper";
import { getAccData } from "../../../service/login/loginService";
export const EmailMobileModification = forwardRef((props: any, ref: any) => {
  // const mandatoryField = useQuery().get("consentType"); //mandatory consent
  let mandatoryField = "";
  const consentList = getAccData("cnsntLst")
    ? getAccData("cnsntLst")
    : JSON.parse(localStorage.getItem("cnsntLst") || "{}");
  let hasEmailMobCons =
    consentList && consentList.length > 0
      ? consentList.some((ele: any) => {
          if (ele.name === "emailMob") return ele;
        })
      : undefined;

  if (hasEmailMobCons) {
    // if (getAccData("accs").emailCnsnt && !getAccData("accs").mobCnsnt)
    //   mandatoryField = "email";
    // else if (!getAccData("accs").emailCnsnt && getAccData("accs").mobCnsnt)
    //   mandatoryField = "mobile";
    // else if (getAccData("accs").emailCnsnt && getAccData("accs").mobCnsnt)
    //   mandatoryField = "emailMob";
    // if(props.childSr)
    mandatoryField = "none";
  }

  const [childSr, setChildSr] = useState<boolean>(
    props.childSr ? props.childSr : false
  );

  const [emailMobileForm, setEmailMobileForm] = useState({
    //form fields
    actualMobileNo: "",
    mobileNo: "",
    actualEmailId: "",
    emailId: "",
    //

    showFamilySection: false,
    familyRelDropdownOptions: [] as any,
    emailAndMobileMatches: [] as any,
    mobileMatches: [] as any,
    emailMatches: [] as any,
    familyDeclFlag: false,
    enableSubmit: true,
    familyDeclReq: [] as any,
  });
  const [errors, setErrors] = useState({
    emailId: "",
    mobileNo: "",
  });
  //const [props.loader, setLoader] = useState(true);
  const [existingEmailMobileSR, setExistingEmailMobileSR] = useState("");
  const [disableMobile, setDisableMobile] = useState(false);
  const [disableEmail, setDisableEmail] = useState(false);
  const [emailOtpVerified, setEmailOtpVerified] = useState(false);
  const [mobOtpVerified, setMobOtpVerified] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [showMobileOtp, setShowMobileOtp] = useState(false);
  const [errorMessage, setErrorMessage] = React.useState<any>();
  const [accCode, setAccCode] = React.useState<string>("");

  React.useEffect(() => {
    if (childSr) {
      getPersonalDetails();
      setEmailMobileForm({
        ...emailMobileForm,
        actualEmailId: props.userData.EmailId
          ? props.userData.EmailId.toLowerCase()
          : "",
        actualMobileNo: props.userData.Mobile ? props.userData.Mobile : "",
        emailId: props.userData.EmailId
          ? props.userData.EmailId.toLowerCase()
          : "",
        mobileNo: props.userData.Mobile ? props.userData.Mobile : "",
      });
      props.setLoader(false);
      if (mandatoryField && childSr) props.childSrB(false);
    } else {
      checkExistingEmailMobSR();
    }

    return () => {};
  }, [props.userData]);

  React.useEffect(() => {
    if (!childSr) props.enableSubmit(emailMobileForm.enableSubmit);
  }, [emailMobileForm.enableSubmit]);
  const isEmailModified = () => {
    return true; //!isEqual(emailMobileForm.actualEmailId, emailMobileForm.emailId);
  };
  const isMobModified = () => {
    return true; //!isEqual(emailMobileForm.mobileNo, emailMobileForm.actualMobileNo);
  };

  const isValidForm = (emailId?: any, mobNo?: any, onChange?: boolean) => {
    return emailMobileForm.emailId &&
      emailMobileForm.mobileNo &&
      !errors.emailId &&
      !errors.mobileNo &&
      onChange
      ? !validateForm("emailId", emailId, false) &&
          !validateForm("mobileNo", mobNo, false)
      : !validateForm("emailId", emailMobileForm.emailId, false) &&
          !validateForm("mobileNo", emailMobileForm.mobileNo, false);
  };

  React.useEffect(() => {
    if (disableMobile && disableEmail) {
      if (emailOtpVerified && mobOtpVerified) {
        getFamilyRelationshipList();
      }
    } else if (disableMobile || disableEmail) {
      getFamilyRelationshipList();
    }

    return () => {};
  }, [emailOtpVerified, mobOtpVerified]);

  React.useEffect(() => {
    if (errors.mobileNo || errors.emailId)
      setEmailMobileForm({ ...emailMobileForm, enableSubmit: false });
    if (isValidForm() && emailMobileForm.familyDeclReq.length > 0) {
      setEmailMobileForm({ ...emailMobileForm, enableSubmit: true });
      if (childSr) props.childSrB(true);
    }

    return () => {};
  }, [emailMobileForm.familyDeclReq, errors]);

  const getBtnText = () => {
    return (
      (//isEmailModified() &&
      ((!disableEmail && !showEmailOtp && !emailOtpVerified) || //isMobModified() &&
        (!disableMobile && !showMobileOtp && !mobOtpVerified)) &&
        isValidForm()) ||
        (childSr && !disableEmail && !disableMobile)
        ? "Generate OTP"
        : !showEmailOtp && !showMobileOtp
        ? "Confirm & Esign"
        : "Submit"
    );
  };
  const getPersonalDetails = async () => {
    try {
      const profile = await asyncGetPersonalDetails();
      if (profile) {
        setAccCode(profile.accountCodeField);
        if (!childSr)
          setEmailMobileForm({
            ...emailMobileForm,
            actualEmailId: profile.emailAddressField
              ? profile.emailAddressField.toLowerCase()
              : "",
            actualMobileNo: profile.mobileNumberField
              ? profile.mobileNumberField
              : "",
            emailId: profile.emailAddressField
              ? profile.emailAddressField.toLowerCase()
              : "",
            mobileNo: profile.mobileNumberField
              ? profile.mobileNumberField
              : "",
          });
        props.setLoader(false);
      }
    } catch (err) {
      // console.log(err);
      openSRErrorPopup();
    }
  };

  const checkExistingEmailMobSR = async () => {
    props.showFooter(true);
    setExistingEmailMobileSR("");
    getPersonalDetails();
  };

  const getFamilyRelRes = async (val: any) => {
    return await GetFamilyRelationshipList({
      Searchvalue: val,
    });
  };

  const isEqual = (val1: number | string, val2: number | string) => {
    return false; //val1 === val2;
  };

  const getFamilyRelationshipList = async () => {
    try {
      if (
        (!disableMobile && disableEmail) ||
        (disableMobile && !disableEmail)
      ) {
        if (!childSr) props.setLoader(true);
        // let payload = {
        //   Searchvalue:
        //     (emailMobileForm.emailMatches.length > 0 || !emailOtpVerified) &&
        //     mobOtpVerified
        //       ? "15BHAUMIK@GMAIL.COM"
        //       : "15BHAUMIK@GMAIL.COM",
        // };
        let familyRelListRes: any;
        familyRelListRes = await getFamilyRelRes(
          (emailMobileForm.emailMatches.length > 0 || !emailOtpVerified) &&
            mobOtpVerified
            ? emailMobileForm.mobileNo
            : emailMobileForm.emailId
        );
        if (!childSr) props.setLoader(false);
        let emailMobMatches: any = [];
        let mobMatches: any = [];
        let emailMatches: any = [];

        if (familyRelListRes && familyRelListRes.objUser) {
          let dropdownOptions: any = familyRelListRes?.objAvailability.filter(
            (ele: any) => {
              return ele.Available > 0 && ele.ValueItem !== 5;
            }
          );
          if (dropdownOptions.length) {
            let familyDet = {
              familyRelDropdownOptions: [
                {
                  value: "",
                  display: "Select Relationship",
                },
              ].concat(
                dropdownOptions.map((ele: any, i: number) => {
                  return { value: ele.Tag, display: ele.Tag };
                })
              ),
              accCode: familyRelListRes?.objUser.Accountcode,
              accName: familyRelListRes?.objUser.AccountName || "",
            };

            if (disableMobile && !disableEmail) mobMatches.push(familyDet);
            if (disableEmail && !disableMobile) emailMatches.push(familyDet);

            if (!familyRelListRes) openSRErrorPopup();
          }
        }

        setEmailMobileForm({
          ...emailMobileForm,
          emailAndMobileMatches: emailMobMatches || [],
          mobileMatches:
            emailMobileForm.mobileMatches.length === 0 ||
            emailMobMatches.length > 0
              ? mobMatches
              : emailMobileForm.mobileMatches,
          emailMatches:
            emailMobileForm.emailMatches.length === 0 ||
            emailMobMatches.length > 0
              ? emailMatches
              : emailMobileForm.emailMatches,
          showFamilySection:
            mobMatches.length > 0 ||
            emailMatches.length > 0 ||
            emailMobMatches.length > 0,
          enableSubmit:
            mobMatches.length === 0 &&
            emailMatches.length === 0 &&
            emailMobMatches.length === 0,
          familyDeclFlag:
            emailMobileForm.mobileMatches.length === 0 ||
            emailMobMatches.length > 0 ||
            emailMobileForm.emailMatches.length === 0 ||
            emailMobMatches.length > 0,
        });
      } else if (disableMobile && disableEmail) {
        if (props.setLoader) props.setLoader(true);
        let mobRelListRes: any;
        mobRelListRes = await getFamilyRelRes(emailMobileForm.mobileNo);

        let emailRelListRes: any;
        emailRelListRes = await getFamilyRelRes(emailMobileForm.emailId);

        if (props.setLoader) props.setLoader(false);
        let emailMobMatches: any = [];
        let mobMatches: any = [];
        let emailMatches: any = [];

        if (
          mobRelListRes &&
          mobRelListRes.objUser &&
          accCode &&
          mobRelListRes.objUser.Accountcode &&
          mobRelListRes.objUser.Accountcode.trim() !== accCode.trim()
        ) {
          let dropdownOptions: any = mobRelListRes?.objAvailability.filter(
            (ele: any) => {
              return ele.Available > 0 && ele.ValueItem !== 5;
            }
          );
          if (dropdownOptions.length > 0) {
            let familyDet = {
              familyRelDropdownOptions: [
                {
                  value: "",
                  display: "Select Relationship",
                },
              ].concat(
                dropdownOptions.map((ele: any, i: number) => {
                  return { value: ele.Tag, display: ele.Tag };
                })
              ),
              accCode: mobRelListRes?.objUser.Accountcode,
              accName: mobRelListRes?.objUser.AccountName || "",
            };

            mobMatches.push(familyDet);

            if (!mobRelListRes) openSRErrorPopup();
          }
        }
        if (
          emailRelListRes &&
          emailRelListRes.objUser &&
          accCode &&
          emailRelListRes.objUser.Accountcode &&
          emailRelListRes.objUser.Accountcode.trim() !== accCode.trim()
        ) {
          let dropdownOptions: any = emailRelListRes?.objAvailability.filter(
            (ele: any) => {
              return ele.Available > 0 && ele.ValueItem !== 5;
            }
          );
          if (dropdownOptions.length > 0) {
            let familyDet = {
              familyRelDropdownOptions: [
                {
                  value: "",
                  display: "Select Relationship",
                },
              ].concat(
                dropdownOptions.map((ele: any, i: number) => {
                  return { value: ele.Tag, display: ele.Tag };
                })
              ),
              accCode: emailRelListRes?.objUser.Accountcode,
              accName: emailRelListRes?.objUser.AccountName || "",
            };

            if (mobMatches.length > 0) {
              let hasDuplicateAccName = hasSameAccName(
                mobMatches,
                familyDet?.accName
              );

              if (hasDuplicateAccName) {
                emailMobMatches.push(familyDet);
              } else emailMatches.push(familyDet);
            } else emailMatches.push(familyDet);

            if (!emailRelListRes) openSRErrorPopup();
          }
        }
        // console.log(
        //   mobMatches,
        //   emailMatches,
        //   emailMobMatches,
        //   "222222222222222222222"
        // );

        setEmailMobileForm({
          ...emailMobileForm,
          emailAndMobileMatches: emailMobMatches || [],
          mobileMatches: emailMobMatches.length > 0 ? [] : mobMatches,
          emailMatches: emailMobMatches.length > 0 ? [] : emailMatches,
          showFamilySection:
            mobMatches.length > 0 ||
            emailMatches.length > 0 ||
            emailMobMatches.length > 0,
          enableSubmit:
            mobMatches.length === 0 &&
            emailMatches.length === 0 &&
            emailMobMatches.length === 0,
          familyDeclFlag:
            mobMatches.length > 0 ||
            emailMatches.length > 0 ||
            emailMobMatches.length > 0,
          familyDeclReq: [],
        });
      }
    } catch (error) {
      // console.log(error);
      openSRErrorPopup();
    }
  };
  const hasSameAccName = (arr: any, accName: string) => {
    return arr[0].accName === accName;
  };
  const validateForm = (inputType: any, val: any, validate: boolean) => {
    let hasError = true;
    switch (inputType) {
      case "mobileNo":
        // if (!validate)
        //   setEmailMobileForm({
        //     ...emailMobileForm,
        //     mobileNo: val,
        //   });
        if (!val.trim() || !integerExp.test(val)) {
          if (validate)
            setErrors({
              ...errors,
              mobileNo: "",
            });
        } else if (val.trim().length > 10 || val.trim().length < 10) {
          if (validate)
            setErrors({
              ...errors,
              mobileNo: "Please enter a valid mobile number.",
            });
        } else {
          hasError = false;
          if (errors.mobileNo)
            setErrors({
              ...errors,
              mobileNo: "",
            });
        }

        break;
      case "emailId":
        // if (!validate)
        //   setEmailMobileForm({
        //     ...emailMobileForm,
        //     emailId: val.toLowerCase(),
        //   });
        if (!val.trim()) {
          if (validate) setErrors({ ...errors, emailId: "" });
        } else if (!emailRegex.test(val)) {
          if (validate)
            setErrors({ ...errors, emailId: "Please enter a valid email id." });
        } else {
          hasError = false;
          if (errors.emailId)
            setErrors({
              ...errors,
              emailId: "",
            });
        }

        break;
    }
    // console.log("hasError", hasError);

    return hasError;
  };
  const checkMandat = () => {
    let mandatoryAnswer =
      (mandatoryField === "email" && isEmailModified()) ||
      (mandatoryField === "mobile" && isMobModified()) ||
      (mandatoryField === "emailMob" && isMobModified() && isEmailModified()) ||
      (mandatoryField === "none" && true);
    if (!mandatoryAnswer && mandatoryField === "email" && childSr) {
      setErrorMessage("Please update email id");
    } else if (!mandatoryAnswer && mandatoryField === "mobile" && childSr) {
      setErrorMessage("Please update mobile no");
    } else if (!mandatoryAnswer && mandatoryField === "emailMob" && childSr) {
      setErrorMessage("Please update an email id and mobile no");
    }
    if (mandatoryAnswer && mandatoryField) setErrorMessage("");
    return mandatoryAnswer;
  };

  const modifySubmit = (emailId: any, mobNo: any) => {
    if (
      // (isEmailModified() || isMobModified()) &&
      isValidForm(emailId, mobNo, true)
    ) {
      let enable = true;
      if (getBtnText() === "Generate OTP") {
        if (disableMobile && showMobileOtp) {
          setShowMobileOtp(false);
        }
        if (disableEmail && showEmailOtp) {
          setShowEmailOtp(false);
        }
        if (emailMobileForm.showFamilySection) {
          setEmailMobileForm({
            ...emailMobileForm,
            enableSubmit: enable,
            showFamilySection: false,
            familyDeclReq: [],
            familyDeclFlag: false,
          });

          if (childSr) props.childSrB(enable);
        } else {
          // console.log("else1,", enable);

          setEmailMobileForm({
            ...emailMobileForm,
            enableSubmit: enable,
          });
          if (childSr)
            props.childSrB(mandatoryField ? checkMandat() && enable : enable);
        }
      } else if (getBtnText() === "Submit") {
        if (disableMobile && !mobOtpVerified) setShowMobileOtp(true);
        if (disableEmail && !emailOtpVerified) setShowEmailOtp(true);
        // console.log("disableMobile", disableMobile, disableEmail);

        if (
          (disableMobile && !mobOtpVerified) ||
          (disableEmail && !emailOtpVerified)
        ) {
          // console.log("22222222222222");
          enable = false;
        }
        if (
          emailMobileForm.mobileMatches.length +
            emailMobileForm.emailAndMobileMatches.length +
            emailMobileForm.emailMatches.length >
          0
        ) {
          // console.log("11111111111111");

          setEmailMobileForm({
            ...emailMobileForm,
            enableSubmit: enable,
            showFamilySection: true,
          });
        } else
          setEmailMobileForm({
            ...emailMobileForm,
            enableSubmit: enable,
          });

        // console.log("else.", enable);

        if (childSr)
          props.childSrB(mandatoryField ? checkMandat() && enable : enable);
      } else {
        if (
          emailMobileForm.mobileMatches.length +
            emailMobileForm.emailAndMobileMatches.length +
            emailMobileForm.emailMatches.length !==
          emailMobileForm.familyDeclReq.length
        ) {
          if (childSr) props.childSrB(false);
          else
            setEmailMobileForm({
              ...emailMobileForm,
              enableSubmit: false,
            });
        } else {
          if (childSr) props.childSrB(true);
          else
            setEmailMobileForm({
              ...emailMobileForm,
              enableSubmit: true,
            });
        }
      }
    } else {
      if (
        ((disableEmail && emailOtpVerified && !disableMobile) ||
          (disableMobile && mobOtpVerified && !disableEmail) ||
          (disableEmail &&
            emailOtpVerified &&
            disableMobile &&
            mobOtpVerified)) &&
        !emailMobileForm.showFamilySection &&
        isValidForm(emailId, mobNo, true)
      ) {
        setEmailMobileForm({ ...emailMobileForm, enableSubmit: true });

        if (childSr) props.childSrB(true);

        // console.log("2...............");
      } else if (
        childSr &&
        isValidForm(emailId, mobNo, true) &&
        !isEmailModified() &&
        !isMobModified()
      ) {
        // console.log("3...................");
        props.childSrB(
          mandatoryField
            ? checkMandat()
            : showEmailOtp ||
              showMobileOtp ||
              (emailMobileForm.showFamilySection &&
                emailMobileForm.mobileMatches.length +
                  emailMobileForm.emailAndMobileMatches.length +
                  emailMobileForm.emailMatches.length !==
                  emailMobileForm.familyDeclReq.length)
            ? false
            : true
        );
      } else {
        setEmailMobileForm({ ...emailMobileForm, enableSubmit: false });
        if (childSr) props.childSrB(false);

        // console.log("else...............");
      }
    }
    if (!childSr) {
      props.setBtnText(getBtnText());
    } else {
      props.setBtnTxt(getBtnText());
    }
  };
  useEffect(() => {
    if (emailMobileForm.emailId || emailMobileForm.mobileNo)
      modifySubmit(emailMobileForm.emailId, emailMobileForm.mobileNo);
  }, [
    emailMobileForm.emailId,
    emailMobileForm.mobileNo,
    showEmailOtp,
    showMobileOtp,
    emailMobileForm.showFamilySection,
  ]);

  useEffect(() => {
    if (disableEmail) setShowEmailOtp(true);
  }, [disableEmail]);

  useEffect(() => {
    if (disableMobile) setShowMobileOtp(true);
  }, [disableMobile]);

  const onChange = (inputType: any, val: any) => {
    let hasErr = validateForm(inputType, val, false); //form validation

    if (inputType == "mobileNo") {
      // modifySubmit(emailMobileForm.emailId, val);
      setEmailMobileForm({
        ...emailMobileForm,
        mobileNo: val,
      });
    } else {
      // modifySubmit(val, emailMobileForm.mobileNo);

      setEmailMobileForm({
        ...emailMobileForm,
        emailId: val,
      });
    }
  };
  const onBlur = (inputType: any, val: any) => {
    let hasErr = validateForm(inputType, val, true); //form validation
    if (!hasErr) {
    } else {
      setEmailMobileForm({ ...emailMobileForm, enableSubmit: false });
    }
  };
  const handleFamilySubmit = (familyDeclReq: any) => {
    setEmailMobileForm({
      ...emailMobileForm,
      familyDeclReq,
    });
  };

  //esign flow
  const proceedToEsign = async (createSRRes: any) => {
    try {
      let result: any = await esignService.proceedToEsign(
        createSRRes.Id,
        "emailMob",
        true
      );
      if (!result) openErrorPopup();
    } catch (err) {
      // console.log(err);

      openErrorPopup();
    }
  };

  const createSR = async (payload: any, val: any) => {
    try {
      let createSRRes = await CreateServiceRequestDetails(payload);
      if (
        typeof createSRRes === "string" &&
        createSRRes.includes("Previous Request already open for this account-")
      ) {
        openExistSrPopup();
        return;
      } else if (
        typeof createSRRes === "string" &&
        createSRRes.includes(
          "One Service Request with same email/mobile is already open"
        )
      ) {
        openDuplicateDetailsSrPopup();
        return;
      } else {
        if (createSRRes && createSRRes.Message) {
          if (val) await proceedToEsign(createSRRes);
          //proceed & esign
          else openSRSuccessPopup(createSRRes);
        } else openSRErrorPopup();
      }
    } catch (err) {
      // console.log(err);

      openSRErrorPopup();
    }
  };

  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("emailMobile", {
      headerText: "You have an active service request",
      content:
        "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };
  const openDuplicateDetailsSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("emailMobile", {
      headerText: "Service request rejected",
      content:
        "The mobile no./email address entered is already in process for updation for a different account. Please update an alternate mobile no./email address to proceed OR since the mobile no./email address pending for updation in a different account is related to you (family account), wait for it to get processed. Once processed, you can use the same mobile no./email address along with family declaration.",
    });
  };
  const openSRSuccessPopup = (createSRRes: any) => {
    props.setLoader(false);
    let paramObj: any = {
      headerText: "We have received your request!",
      content:
        "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
      popupType: "Success",
    };

    if (createSRRes.base64Data) {
      paramObj.btnText = "Download E-Signed Form";
      paramObj.base64Data = createSRRes.base64Data;
    }
    props.onSubmit("emailMobile", paramObj);
  };
  const openSRErrorPopup = () => {
    props.setLoader(false);
    if (!childSr)
      props.onSubmit("emailMobile", {
        headerText:
          "There was some problem in raising service request. Please try again later.",
      });
  };
  const openErrorPopup = () => {
    props.setLoader(false);
    if (!childSr)
      props.onSubmit("emailMobile", {
        headerText: "There was some error while proceeding with esign process.",
      });
  };
  const submitForm = async (val?: any) => {
    if (childSr) {
      setDisableMobile(true);
      setDisableEmail(true);
      setEmailMobileForm({ ...emailMobileForm, enableSubmit: false });
      return;
    } else if (
      (!showMobileOtp &&
        !mobOtpVerified &&
        !isEqual(emailMobileForm.actualMobileNo, emailMobileForm.mobileNo)) ||
      (!isEqual(emailMobileForm.actualEmailId, emailMobileForm.emailId) &&
        !showEmailOtp &&
        !emailOtpVerified)
    ) {
      // console.log("11111111111111111111111");

      if (
        !isEqual(emailMobileForm.actualMobileNo, emailMobileForm.mobileNo) &&
        !mobOtpVerified
      ) {
        // console.log("1");

        // setShowMobileOtp(true);
        setDisableMobile(true);
      }
      if (
        !isEqual(emailMobileForm.actualEmailId, emailMobileForm.emailId) &&
        !emailOtpVerified
      ) {
        // console.log("2");

        // setShowEmailOtp(true);
        setDisableEmail(true);
      }
      setEmailMobileForm({ ...emailMobileForm, enableSubmit: false });
      return;
    } else {
      props.setLoader(true);
      let payload = {
        requestType: "Email & Mobile Modification",
        dpID: await getDepositoryDet(),
        new_mobile_number: emailMobileForm.mobileNo,
        new_email_id: emailMobileForm.emailId,
        old_mobile_number: emailMobileForm.actualMobileNo,
        old_email_id: emailMobileForm.actualEmailId,
        familyDeclReq: emailMobileForm.familyDeclReq,
        family_declaration_flag: emailMobileForm.familyDeclReq.length > 0,
        AutoQC: "NA",
      };

      try {
        if (disableMobile) {
          try {
            var consentRes = await SendWhatsappConsent({
              type: "optin",
              recipients: [
                {
                  recipient: emailMobileForm.mobileNo,
                  source: "edel-web",
                },
              ],
            });
            if (!consentRes || !consentRes.data.sts) openSRErrorPopup();
            else createSR(payload, val);
          } catch (err) {
            // console.log(err);

            openSRErrorPopup();
          }
        } else createSR(payload, val);
      } catch (err) {
        // console.log(err);

        openSRErrorPopup();
      }
    }
  };

  const setData = (key: any) => {
    if (key === "emailId") {
      setEmailOtpVerified(true);
      setShowEmailOtp(false);
    }
    if (key === "mobileNo") {
      setMobOtpVerified(true);
      setShowMobileOtp(false);
    }
  };
  const getDepositoryDet = async () => {
    try {
      const resp = await GetDepositoryDetails();

      if (resp && resp.dPIdField && resp.dPAccountNumberField) {
        return resp.dPIdField + resp.dPAccountNumberField;
      } else {
        return "None";
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };
  useImperativeHandle(ref, () => ({
    submitData(val: any) {
      if (val !== "Submit") submitForm("proceed to esign");
      else submitForm();
    },
    getSubmitData() {
      const reqObj = {
        new_mobile_number: emailMobileForm.mobileNo,
        new_email_id: emailMobileForm.emailId,
        old_mobile_number: emailMobileForm.actualMobileNo,
        old_email_id: emailMobileForm.actualEmailId,
        familyDeclReq: emailMobileForm.familyDeclReq,
        family_declaration_flag: emailMobileForm.familyDeclReq.length > 0,
      };

      let emailMobileFormObj = {
        ...emailMobileForm,
        showEmailOtp,
        showMobileOtp,
        mobOtpVerified,
        emailOtpVerified,
        btnText: getBtnText(),
      };
      return { reqObj, emailMobileFormObj };
    },
  }));

  return (
    <>
      {!props.loader && (
        <>
          {existingEmailMobileSR ? (
            <StatusScreen
              headerText="Email & Mobile Modification in Process"
              desc="Another Email or Mobile modification request is under process. Please raise any new requests only once those are processed."
              status="Pending"
            />
          ) : (
            ""
          )}
          {!existingEmailMobileSR && (
            <>
              <div className="row custom--row mobile--row">
                <div className="form-field custom-col email-phone">
                  <label className="input-label">Mobile Number</label>
                  <div className="phone">
                    <div>
                      <p className="code">+91</p>
                    </div>

                    <InputField
                      onChange={(value) => {
                        onChange("mobileNo", value);
                      }}
                      defaultValue={emailMobileForm.mobileNo}
                      onBlur={() => {
                        // onBlur("mobileNo",emailMobileForm.mobileNo);
                      }}
                      onMouseOut={(val) => {
                        onBlur("mobileNo", val);
                      }}
                      className="formInpCont mgT7"
                      placeholder=""
                      maxLength={10}
                      required
                      integer={true}
                      disabled={disableMobile}
                      helpTextColor="blue"
                      // errorText={errors.mobileNo}
                      suffix={
                        mobOtpVerified ? (
                          <i className="edel-icon-tick icon"></i>
                        ) : (
                          ""
                        )
                      }
                    ></InputField>
                  </div>

                  <p className="help_text red">{errors.mobileNo}</p>
                  {!isMobModified() &&
                    (mandatoryField === "mobile" ||
                      mandatoryField === "emailMob") && (
                      <p className="help_text red">Please update mobile.</p>
                    )}

                  {showMobileOtp && (
                    <div className="">
                      <OtpSection
                        details={{
                          mobileNo: emailMobileForm.mobileNo,
                          type: "mobileNo",
                        }}
                        otpVerified={() => {
                          setData("mobileNo");
                        }}
                        verifyDisabled={
                          errors.mobileNo ||
                          errors.emailId ||
                          !emailMobileForm.mobileNo ||
                          !emailMobileForm.emailId
                        }
                      />
                    </div>
                  )}
                  {!showMobileOtp && showEmailOtp && (
                    <div className="custom-col"></div>
                  )}
                </div>
                <div className="form-field custom-col email-phone ">
                  <label className="input-label">Email ID</label>

                  <InputField
                    onChange={(value) => {
                      onChange("emailId", value.toLowerCase());
                      return value.toLowerCase();
                    }}
                    defaultValue={emailMobileForm.emailId}
                    className="formInpCont mgT7"
                    placeholder=""
                    disabled={disableEmail}
                    onBlur={() => {
                      // onBlur("emailId",emailMobileForm.emailId);
                    }}
                    suffix={
                      emailOtpVerified ? (
                        <i className="edel-icon-tick icon"></i>
                      ) : (
                        ""
                      )
                    }
                    onMouseOut={(val) => {
                      onBlur("emailId", val);
                    }}
                    required
                    helpTextColor="blue"
                    errorText={errors.emailId}
                  ></InputField>
                  {!isEmailModified() &&
                    (mandatoryField === "email" ||
                      mandatoryField === "emailMob") && (
                      <p className="help_text red">Please update email Id.</p>
                    )}

                  {showEmailOtp && (
                    <div className="">
                      <OtpSection
                        details={{
                          emailId: emailMobileForm.emailId,
                          type: "emailId",
                        }}
                        otpVerified={() => {
                          setData("emailId");
                        }}
                        verifyDisabled={
                          errors.mobileNo ||
                          errors.emailId ||
                          !emailMobileForm.mobileNo ||
                          !emailMobileForm.emailId
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
              {emailMobileForm.showFamilySection &&
                !showEmailOtp &&
                !showMobileOtp && (
                  <FamilySection
                    emailMobileForm={emailMobileForm}
                    onFamilySubmit={handleFamilySubmit}
                  ></FamilySection>
                )}
              {disableMobile && (
                <div className="incomeDeclare">
                  <div className="display-flex declarationWrap">
                    <Checkbox checked={true} name="consent" onChange={() => {}}>
                      <span className="incomeMsg regular-font declare">
                        {" "}
                        I am aware that my contact details will be used for all
                        future communications by Nuvama, including
                        communications through WhatsApp.
                      </span>
                    </Checkbox>{" "}
                  </div>
                </div>
              )}
              {/* {childSr && errorMessage && <>
                <p className="error-msg">
                  {errorMessage}
                </p>
              </>
              } */}
              {!childSr && (
                <>
                  <p className="text-indicator small--text-indicator noSpaceIndicator">
                    The changes mentioned will be applicable for your Trading
                    and Default Demat account
                  </p>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
});
